"use client";

import { Button } from "@/components/ui/button";
import { Menu } from "lucide-react";
import { useState } from "react";
import Image from "next/image";
import Link from "next/link";

export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-border/40 bg-primary/95 backdrop-blur supports-[backdrop-filter]:bg-primary/80">
      <div className="container mx-auto px-4">
        <div className="flex h-16 items-center justify-between">
          <div className="flex items-center gap-2">
            <Link href="/">
              <Image
                src="/edukate-white.png"
                alt="Edukate Africa"
                width={80}
                height={20}
                className="h-8 w-auto"
              />
            </Link>
          </div>

          <nav className="hidden items-center gap-6 md:flex">
            <Link
              href="#about"
              className="relative text-sm font-medium text-primary-foreground/90 transition-all duration-300 hover:text-primary-foreground after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-secondary after:transition-all after:duration-300 hover:after:w-full"
            >
              About
            </Link>
            <Link
              href="#sessions"
              className="relative text-sm font-medium text-primary-foreground/90 transition-all duration-300 hover:text-primary-foreground after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-secondary after:transition-all after:duration-300 hover:after:w-full"
            >
              Sessions
            </Link>
            <Link
              href="#agenda"
              className="relative text-sm font-medium text-primary-foreground/90 transition-all duration-300 hover:text-primary-foreground after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-secondary after:transition-all after:duration-300 hover:after:w-full"
            >
              Agenda
            </Link>
            <Link
              href="/speakers-partners"
              className="relative text-sm font-medium text-primary-foreground/90 transition-all duration-300 hover:text-primary-foreground after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-secondary after:transition-all after:duration-300 hover:after:w-full"
            >
              Speakers & Partners
            </Link>
            <Link href="/register">
              <Button className="bg-secondary text-secondary-foreground hover:bg-secondary/90 hover:scale-105 transition-all duration-300">
                Register Now
              </Button>
            </Link>
          </nav>

          <button
            className="md:hidden text-primary-foreground"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <Menu className="h-6 w-6" />
          </button>
        </div>

        {mobileMenuOpen && (
          <nav className="flex flex-col gap-4 pb-4 md:hidden">
            <Link
              href="#about"
              className="text-sm font-medium text-primary-foreground/90"
            >
              About
            </Link>
            <Link
              href="#sessions"
              className="text-sm font-medium text-primary-foreground/90"
            >
              Sessions
            </Link>
            <Link
              href="#agenda"
              className="text-sm font-medium text-primary-foreground/90"
            >
              Agenda
            </Link>
            <Link
              href="/speakers-partners"
              className="text-sm font-medium text-primary-foreground/90"
            >
              Speakers & Partners
            </Link>
            <Link href="/register" className="w-full">
              <Button className="bg-secondary text-secondary-foreground hover:bg-secondary/90 w-full">
                Register Now
              </Button>
            </Link>
          </nav>
        )}
      </div>
    </header>
  );
}
